module.exports = __webpack_public_path__ + "static/media/datto_autotask_psa_logo.c068e3ff.png";